export function service () {
  fetch('assets/service.json')
    .then(response => {
      return response.json();
    })
    .then(json => {
      drawList(json);
    });
}

function drawList(json) {
  const serviceContainer = document.querySelector('.service__ul');
  serviceContainer.innerHTML = '';

  json.forEach(function (element, i) {
    let after = '';
    if (i > 0) {
      after = 'service__title--locked';
    };

    serviceContainer.innerHTML += `
<li class="service__el">
<a href="${element.id}">
  <div class="service__img">
    <img src="${element.picture}" alt="${element.name}"/>
  </div>
  <div class="service__content">
    <h3 class="service__title ${after}">
      <span class="service__span">${element.name}</span> 
    </h3>
    <p class="service__points">
    ${element.points} Logia
    </p>
  </div>
</a>
</li>`;
    const aElement = document.querySelectorAll('.service__el a');

    aElement.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const idAttr = e.currentTarget.getAttribute('href');

        if (idAttr == 1) {
          const descEl = document.querySelectorAll('.service__parts');

          descEl.forEach(part => {
            part.classList.remove('service__parts--hidde');
          });

          document.querySelector('.service__all').classList.add('service__parts--hidde');
        }
      });
    });
  });
}
